<div class="shift-history-container">
  <div class="history-accordion">
    <span
      class="history-toggle"
      (click)="toggleDropdown()"
      [attr.aria-expanded]="isOpen"
    >
      {{ 'clockHour.history.title' | translate }}
      <icon-svg
        class="arrow-icon"
        type="linear/chevron-down"
        size="20"
        strokeColor="#3C48EC"
        fillColor="none"
        [class.open]="isOpen"
      ></icon-svg>
    </span>

    <div class="history-content" *ngIf="isOpen" [@slideDown]>
      <!-- Loading State -->
      <div *ngIf="isLoading" class="loading-state">
        <div class="spinner"></div>
      </div>

      <!-- Empty State -->
      <div *ngIf="!isLoading && changes.length === 0" class="empty-state">
        <p>{{ 'clockHour.history.noChanges' | translate }}</p>
      </div>

      <!-- Changes List -->
      <div
        *ngIf="!isLoading && !error && changes.length > 0"
        class="changes-list"
      >
        <div
          *ngFor="let change of changes"
          class="change-item"
          [attr.data-type]="change.type"
        >
          <div class="change-marker"></div>
          <div class="change-content">
            <h4 class="change-title">{{ change.title }}</h4>
            <div class="change-meta">
              <span class="change-datetime"
                >{{ change.date }} | {{ change.time }}</span
              >
            </div>
            <p class="change-description">
              {{ change.description }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
